import * as actions from "./actions";
import * as selectors from "./selectors";
import reducer from "./reducer";
import sagas from "./sagas";

export default {
  actions,
  createSagas: sagas,
  reducer,
  selectors,
};
